module.exports = __webpack_public_path__ + "static/media/PIOJ-High-res.a714ab37.png";